export default "__VITE_ASSET__BlK9D_rQ__"